import { createI18n } from "vue-i18n";
import { nextTick } from "vue";
import { langGetTranslatesByKey } from "@/services/lang";

export const SUPPORT_LOCALES = ["ky", "ru"];
const translates = {};

const i18n = createI18n({
  locale: "ky",
  legacy: false,
  missingWarn: false,
  fallbackWarn: false,
});

export function setI18nLanguage(locale) {
  if (i18n.mode === "legacy") {
    i18n.global.locale = locale;
  } else {
    i18n.global.locale.value = locale;
  }
  localStorage.setItem("locale", locale);
  document.querySelector("html").setAttribute("lang", locale);
  loadLocaleMessages(locale).then((r) => null);
}

export async function loadLocaleMessages(locale) {
  if (locale in translates) {
    return;
  }

  try {
    const messages = await langGetTranslatesByKey(locale);
    translates[locale] = true;

    await i18n.global.setLocaleMessage(locale, messages.data.translations);
  } catch (e) {}

  return nextTick();
}

export function initI18n() {
  const locale = localStorage.getItem("locale") ?? "ky";
  setI18nLanguage(locale);
}

export default i18n;
